module.exports = __webpack_public_path__ + "static/media/edit-icon-orange.25eb2bfe.svg";